import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import { ResourceCollection } from "@/modules/api/resource.collection";

import FactoryRushCapacityProductGroupMember from "./factory-rush-capacity-product-group-member.model";

export default class FactoryRushCapacityProductGroupMemberRepository extends BasicRepository<FactoryRushCapacityProductGroupMember> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<FactoryRushCapacityProductGroupMember>,
    responseParser: ApiCollectionResponseParserService<FactoryRushCapacityProductGroupMember>
  ) {
    super(
      "factory_rush_capacity_product_group_members",
      api,
      objectBuilder,
      responseParser
    );
  }

  public getAll(
    useCache = true
  ): Promise<ResourceCollection<FactoryRushCapacityProductGroupMember>> {
    return this.fetchList({}, 1, 9999, undefined, useCache);
  }

  protected prepareData(
    item: FactoryRushCapacityProductGroupMember
  ): Record<string, string | number> {
    return {
      product: Number.parseInt(item.product, 10),
      productGroup: item.productGroup,
    };
  }
}
